// extracted by mini-css-extract-plugin
export default {"radialGradient":"radial-gradient_radialGradient__x4QUP","secondary-background":"radial-gradient_secondary-background__Nsh8m"};